import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { useGetPublishedOfferingEntitlementsAndCheckInstitutionalIndicationAccess } from '../../common/util/check-access/useGetPublishedOfferingEntitlementsAndCheckInstitutionalIndicationAccess';
import { useOfferingSidePanelMatch } from './hooks/useOfferingSidePanelMatch';
import SellSideOfferingDetailsRoute from './offering-details/SellSideOfferingDetailsRoute';
import offeringSidePanelBuySideRouteFactory from './offeringSidePanelBuySideRouteFactory';
import offeringSidePanelSellSideRouteFactory from './offeringSidePanelSellSideRouteFactory';
import { OfferingSidePanelSummaryRoute } from './OfferingSidePanelSummaryRoute';
import {
  OrderBookPersonaType,
  useIdentifyOrderBookPersona,
} from './order-book/hooks/useIdentifyOrderBookPersona';
import NotesRoute from './order-book/notes/NotesRoute';
import OrderBookSellSideRoute from './order-book/OrderBookSellSideRoute';

export type Props = {
  offeringId?: string;
};

// `rest` isn't a real router location (see hooks/useOfferingSidePanelMatch.ts) — `<Routes
// location={rest}>` matches against it explicitly instead of the actual browser location.
const OfferingSidePanelSellSideRoutes: React.FC<Props> = ({ offeringId }) => {
  const { type } = useIdentifyOrderBookPersona({ offeringId });
  const { canUpdate: canUpdateInstitutionalIndication } =
    useGetPublishedOfferingEntitlementsAndCheckInstitutionalIndicationAccess({
      offeringId,
    });

  const sidePanelMatch = useOfferingSidePanelMatch();
  const rest = sidePanelMatch?.rest || '/';

  return (
    <Routes location={rest}>
      <Route
        path={`${offeringSidePanelSellSideRouteFactory.offeringDetails.routePath}/*`}
        element={<SellSideOfferingDetailsRoute />}
      />
      <Route
        path={`${offeringSidePanelSellSideRouteFactory.orderBook.routePath}/*`}
        element={<OrderBookSellSideRoute />}
      />
      {type === OrderBookPersonaType.SYNDICATE && canUpdateInstitutionalIndication && (
        <Route
          path={`${offeringSidePanelSellSideRouteFactory.orderBookNotes.routePath}/*`}
          element={<NotesRoute />}
        />
      )}
      <Route
        path={`${offeringSidePanelBuySideRouteFactory.offeringSummary.routePath}/*`}
        element={<OfferingSidePanelSummaryRoute />}
      />
      {/* matches the v5 `root` route (exact "/"), which rendered nothing */}
      <Route path="*" element={null} />
    </Routes>
  );
};

export default OfferingSidePanelSellSideRoutes;
